import React from "react";
import Text from "../../Text";
import styled, { css } from "styled-components";
import * as colors from "../../../assets/_base/colors";
import Icon from "../../Icon";
import Spinner from "../../Spinner";

const ButtonContainer = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  background-color: #056baa; 
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24); 
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  color: white ;
`;

const PlusContainer = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 10px 1px;
  background-color: #056baa; 
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24); 
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  color: white ;
`;

const CreditText = styled.span`
  font-weight: bold;
  margin-left: 3px;
`;


export default (props) => {
  return (<div>


    <ButtonContainer style={{ cursor: 'pointer' }} {...props}>
      {props.icon &&
        (props.iconPosition == "left" || props.iconPosition == undefined) ? (
        <Icon type={props.type} className={`${props.icon} left`} />
      ) : (
        <React.Fragment />
      )}
      <span>Notas Disponíveis: <CreditText>{props.label}</CreditText> </span>
    </ButtonContainer>

    <PlusContainer style={{ cursor: 'pointer' }} {...props}>

      <Icon type={props.type} className={`fas fa-plus left`} />

    </PlusContainer>
  </div>
  );
};


// WEBPACK FOOTER //
// ./src/_components/Button/IconButton/index.jsx